<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>

            

            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1>Stage One Requirements Agreement</h1>
                    <p>Following your questionnaire and the conversations that have taken place, we have identified the following requirements at this stage of the project, please click each requirement to provide further details or to review the agreement.</p>
                </div>

                <div class="cell small-12">
                    <Panel
                        v-for="(agreementTask, idx) in agreementTasks.taskLinks"
                        :key="idx"
                        :title="agreementTask.requirementAgreementTask.taskName"
                        :description="'Agreement for your ' + splitByCapitals(agreementTask.requirementAgreementTask.taskName)"
                        :status="agreementStatusText(agreementTask.requirementAgreementTask.agreementStatus)"
                        :icon="getIconByType(agreementTask.requirementAgreementTask.agreementType)"
                        :route="{ name: 'RequirementAgreement', params: { agreementId: agreementTask.requirementAgreementTask.taskId } }"
                    />
                </div>
            </div>
            <br/>
            <button class="btn btn-secondary" @click="router.push({ name: 'Home' })">Return to Home</button>
        </section>

        


</div>


  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getPreSlaRequirementsAgreement, getRequirementAgreementTask } from '@/services/implementationmanagement.api';
import { splitByCapitals } from '@/helpers/strings';
import Panel from '@/components/controls/Panel.vue'
import { icons } from '@/assets/icons'


const router  = useRouter()
const loaded = ref(false);
const taskId = router.currentRoute.value.params.taskId;
const error = ref(null);
const agreementTasks = ref(null);
const icon = icons.cog

const errorString = 'An error has occurred. Please contact your Qtac account manager.';


const agreementStatusText = computed(() => (status) => {
    switch (status) {
        case 'WithInternalNegotiator':
            return 'In Review';
        case 'WithInternalReviewer':
            return 'In Review';
        case 'WithClient':
            return 'Awaiting Your Response';
        case 'Drafting':
            return 'Not Started';
        case 'Closed':
            return 'Completed';
        default:
            return 'Unknown Status';
    }
});


onMounted(async () => {

    try {
        
        var taskResponse = await getPreSlaRequirementsAgreement(taskId);

        if(taskResponse.status !== 200 || taskResponse.data === null || taskResponse.data === undefined) {
            error.value = errorString;
            return null;
        }

        agreementTasks.value = taskResponse.data;


    } catch (err) {
        error.value = errorString;
        console.error(err);
    }




loaded.value = true;
})


function getIconByType(type) {

    switch (type) {
        case 'ReportRequirements':
            return icons.document1;
        case 'ResourceCosting':
            return icons.paymentscreen;
        case 'TimesheetRequirements':
            return icons.calendarcheck;
        case 'AdditionalRequirements':
            return icons.conversationquestion;
        default:
            return icons.cog;
    }
}





</script>

